import { Injectable } from '@angular/core';
import { ContenidoDeEstadoDePago } from 'src/app/pago/models/ContenidoDeEstadoDePago.model';
import { ContenidoEstadosDTO } from 'src/app/pago/dtos/ContenidoEstadosDTO.model';

@Injectable({
  providedIn: 'root',
})
export class ContenidoEstadoPagoFactory {
  convertToModel = (
    contenidoEstado: ContenidoEstadosDTO
  ): ContenidoDeEstadoDePago => {
    return {
      ...contenidoEstado,
      titulo: contenidoEstado.titulo,
      informacionReintentos:
        contenidoEstado.informacionReintentos !== null
          ? contenidoEstado.informacionReintentos
          : null,
      descripcion: contenidoEstado.descripcion,
      textoEncuestaDeSatisfaccion: contenidoEstado.textoEncuestaDeSatisfaccion,
    };
  };
}
